import { Component, inject, Inject } from '@angular/core';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { VesselRedundancyWcfdi } from '../../dto/vessel-redundancy-wcfdi';

@Component({
  selector: 'dpi-vessel-redundancy-wcfdi-details',
  imports: [MatInputModule, MatFormFieldModule, FormsModule, MatButtonModule, MatIconModule, MatTooltipModule, MatDialogModule],
  templateUrl: './vessel-redundancy-wcfdi-details.component.html',
  styleUrl: './vessel-redundancy-wcfdi-details.component.scss'
})
export class VesselRedundancyWcfdiDetailsComponent {
  readonly dialogRef = inject(MatDialogRef<VesselRedundancyWcfdiDetailsComponent>);
  redundancyWcfdi : VesselRedundancyWcfdi;
  isToUpdate: boolean;
  isToDelete: boolean;

  constructor(@Inject(MAT_DIALOG_DATA) public data: VesselRedundancyWcfdi) {
    this.redundancyWcfdi = data;
    this.isToUpdate = false;
    this.isToDelete = false;
  }

  onCancelClick(): void {
    this.dialogRef.close();
  }

  onUpdateClick() {
    this.isToUpdate = true;
  }

  onDeleteClick() {
    this.isToDelete = true;
    this.dialogRef.close();
  }
}
